// components/LugarTable.jsx
import React from 'react';
import { FaEdit, FaToggleOn, FaToggleOff, FaMapMarkerAlt, FaCalendarAlt } from 'react-icons/fa';

const LugarTable = ({ lugares, onEdit, onToggleStatus }) => {
  return (
    <div className="overflow-x-auto rounded-lg shadow">
      <table className="min-w-full bg-zinc-800 divide-y divide-zinc-700">
        <thead>
          <tr>
            <th className="px-6 py-3 bg-zinc-700 text-left text-xs font-medium text-gray-300 uppercase tracking-wider">
              Lugar
            </th>
            <th className="px-6 py-3 bg-zinc-700 text-left text-xs font-medium text-gray-300 uppercase tracking-wider">
              Ubicación
            </th>
            <th className="px-6 py-3 bg-zinc-700 text-left text-xs font-medium text-gray-300 uppercase tracking-wider">
              Descripción
            </th>
            <th className="px-6 py-3 bg-zinc-700 text-center text-xs font-medium text-gray-300 uppercase tracking-wider w-32">
              Eventos
            </th>
            <th className="px-6 py-3 bg-zinc-700 text-center text-xs font-medium text-gray-300 uppercase tracking-wider w-24">
              Estado
            </th>
            <th className="px-6 py-3 bg-zinc-700 text-right text-xs font-medium text-gray-300 uppercase tracking-wider w-32">
              Acciones
            </th>
          </tr>
        </thead>
        <tbody className="divide-y divide-zinc-700">
          {lugares.length > 0 ? (
            lugares.map((lugar, index) => (
              <tr 
                key={lugar.lugarEventoId || lugar.id || `lugar-${index}`} 
                className={`hover:bg-zinc-700 transition-colors ${!lugar.habilitado ? 'opacity-60' : ''}`}
              >
                <td className="px-6 py-4">
                  <div className="flex items-center">
                    <div className="flex-shrink-0 h-16 w-16 bg-zinc-700 rounded-lg overflow-hidden">
                      <img 
                        src={lugar.imagen} 
                        alt={lugar.nombre} 
                        className="h-full w-full object-cover"
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = 'https://via.placeholder.com/100x100?text=Sin+Imagen';
                        }}
                      />
                    </div>
                    <div className="ml-4">
                      <div className="text-sm font-medium text-white">{lugar.nombre}</div>
                    </div>
                  </div>
                </td>
                
                <td className="px-6 py-4">
                  <div className="text-sm space-y-1">
                    <div className="flex items-center text-white">
                      <FaMapMarkerAlt className="mr-2 text-gray-400 text-xs" />
                      <span>{lugar.direccion}</span>
                    </div>
                    <div className="text-gray-400 text-xs">
                      {lugar.ciudad}, {lugar.region}
                    </div>
                  </div>
                </td>
                
                <td className="px-6 py-4">
                  <div className="text-sm text-gray-300 max-w-xs">
                    <p className="truncate" title={lugar.descripcion || "Sin descripción"}>
                      {lugar.descripcion || "Sin descripción"}
                    </p>
                  </div>
                </td>
                
                {/* ✅ Columna de eventos mejorada */}
                <td className="px-6 py-4 text-center">
                  <div className="flex flex-col items-center space-y-1">
                   
                    <div className="text-sm font-medium text-white">
                      {lugar.cantidadEventos || 0}
                    </div>
                    <div className="text-xs text-gray-400">
                      eventos
                    </div>
                  </div>
                </td>
                
                <td className="px-6 py-4 text-center">
                  <span className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium 
                    ${lugar.habilitado 
                      ? 'bg-green-100 text-green-800' 
                      : 'bg-red-100 text-red-800'}`}
                  >
                    {lugar.habilitado ? 'Activo' : 'Inactivo'}
                  </span>
                </td>
                
                <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                  <div className="flex justify-end space-x-2">
                    <button
                      onClick={() => onEdit(lugar)}
                      className="p-2 rounded-lg bg-blue-100 text-blue-600 hover:bg-blue-200 transition-colors"
                      title="Editar lugar"
                    >
                      <FaEdit />
                    </button>
                    <button
                      onClick={() => onToggleStatus(lugar)}
                      className={`p-2 rounded-lg transition-colors ${lugar.habilitado 
                        ? 'bg-red-100 text-red-600 hover:bg-red-200' 
                        : 'bg-green-100 text-green-600 hover:bg-green-200'}`}
                      title={lugar.habilitado ? "Deshabilitar lugar" : "Habilitar lugar"}
                    >
                      {lugar.habilitado ? <FaToggleOff /> : <FaToggleOn />}
                    </button>
                  </div>
                </td>
              </tr>
            ))
          ) : (
            <tr key="no-results">
              <td colSpan="6" className="px-6 py-12 text-center text-gray-400">
                No se encontraron lugares que coincidan con la búsqueda.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default LugarTable;